import script from "./MyTasksView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyTasksView.vue?vue&type=script&setup=true&lang=ts"

import "./MyTasksView.vue?vue&type=style&index=0&id=221235e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221235e8"]])

export default __exports__